<template>
    <v-btn-toggle multiple light dense>
        <v-btn color="#ebf0f4" href="https://github.com/coroot/coroot" target="_blank">
            <v-icon>mdi-github</v-icon>
            Star
        </v-btn>
        <v-btn v-if="data" color="white" href="https://github.com/coroot/coroot/stargazers" target="_blank">
            {{addCommas(data.stargazers_count)}}
        </v-btn>
    </v-btn-toggle>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        count: Boolean,
    },
    data() {
        return {
            data: null,
        };
    },
    created() {
        if (!this.count) {
            return;
        }
        axios.get('https://api.github.com/repos/coroot/coroot').then((response) => {
            this.data = response.data;
        });
    },
    methods: {
        addCommas(n) {
            return String(n).replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        },
    },
}
</script>

<style scoped>
</style>
